import script from "./EditArtikel.vue?vue&type=script&setup=true&lang=js"
export * from "./EditArtikel.vue?vue&type=script&setup=true&lang=js"

import "./EditArtikel.vue?vue&type=style&index=0&id=671add98&lang=css"

const __exports__ = script;

export default __exports__